import script from "./record-product-block.vue?vue&type=script&lang=ts&setup=true"
export * from "./record-product-block.vue?vue&type=script&lang=ts&setup=true"

import "./record-product-block.vue?vue&type=style&index=0&id=242ba5aa&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242ba5aa"]])

export default __exports__